// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PgKxL","developer":"Footer_developer__BtzA3"};